import React from 'react'
import { Button, Col, Row } from 'reactstrap'
import { BsCheckLg } from "react-icons/bs";

const ToxicologyPanelConducting = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding6rem right-padding6rem pb-5'>
            <Row className='reverse-section'>
                <Col md='12' lg='4' className='d-sm-flex d-md-flex justify-content-center py-md-4'>
                    <img className='img-w24' src='https://unitedlabcare.com/wp-content/uploads/2023/05/Toxicology-Testing-img2-v1.webp' alt='Pic'  />
                </Col>

                <Col md='12' lg='8' className=''>
                    <div className='pt-md-'>
                        <div className='pe-md-5'>
                            <text className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh-1-2'>
                                Let Us Conduct Full Toxicology Panels On Your Patients!
                            </text>
                            <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
                        </div>

                        <div className=''>
                            <ul className='fs-ss-16-1 text-montserrat text-ss-black fw-600' style={{ marginLeft:'-30px'}}>
                                <li className='py-3 flex-cente' style={{ display:'flex', listStyleType:'none',}}>
                                <BsCheckLg className='text-ss-primary me-2 fs-ss-22'/> Turn Around Time: Under 24 Hrs
                                </li>
                                <li className='pb-3 flex-cente' style={{ display:'flex', listStyleType:'none',}}>
                                <BsCheckLg className='text-ss-primary me-2 fs-ss-22'/> Stat Testing Available: Under 4 Hrs
                                </li>
                                <li className='pb-3 flex-cente' style={{ display:'flex', listStyleType:'none',}}>
                                <BsCheckLg className='text-ss-primary me-2 fs-ss-22'/> Test Anywhere: At Your Clinic Or At Our Clinic
                                </li>
                                <li className='pb-3 flex-cente' style={{ display:'flex', listStyleType:'none',}}>
                                <BsCheckLg className='text-ss-primary me-2 fs-ss-22'/>  Results Released Directly Into Your Patient Software
                                </li>
                                <li className='pb-2 flex-cente' style={{ display:'flex', listStyleType:'none',}}>
                                <BsCheckLg className='text-ss-primary me-2 fs-ss-22'/>  Our Drug Panel Test Detects For 15 Toxins & Over 100 Different Drugs
                                </li>
                            </ul>
                        </div>
                    </div>
                </Col>
            </Row>

            <div className='pt-md-5 pt-5'>
            <div className='left-padding8rem right-padding8rem' style={{ }}>
                <div className='bg-img rounded30' style={{ boxShadow:'0 0 10px 0 rgba(0,0,0,.5)', backgroundImage:'url("https://unitedlabcare.com/wp-content/uploads/2022/12/RSV-Testing-bg2.png")', width:'100%'}}>
                    <div className='py-4 px-md-0 px-4'>
                    <text className='fs-ss-26-5 text-montserrat text-white fw-600 lh-1-2'>
                        <center>
                            WE ALSO OFFER A FULL BLOOD WORK PANEL
                            <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
                        </center>
                    </text>    
                    </div>

                    <div className='pb-3 pt-md-2'>
                        <center>
                            <Button className='btn-ss-secondary rounded20 ' style={{  boxShadow:'1px 1px 6px 0 rgba(0,0,0,.4)'}}>
                                <text className='text-montserrat fw-600 fs-ss-18' style={{ padding:'12px 14px',}}>
                                    Contact Us
                                </text>
                            </Button>
                        </center>
                    </div>
                </div>
            </div>
            </div>
        </div>
    </div>
  )
}

export default ToxicologyPanelConducting